import React from 'react';
import System from '../../basic/System';
import { isMobile } from '../../util/ScreenUtil';
import ThumbnailUtil from '../../util/ThumbnailUtil';
import { getMaxWindowPixelDimension } from '../../ViewUtil';

export default class HomeBanner extends React.Component {
  render() {
    // Banner image and layout designed for 1550x380 for 900p to 1080p screens; i.e. typically 1440x900 to 1920x1080.
    const scaleFactor = Math.ceil(window.innerWidth / 775) / 2; // 775 = (1550 / 2);
    // Scale banner height with width but limit it to at most half the screen height.
    const height = Math.min(window.innerHeight / 2, scaleFactor * 380);
    const maxWindowDimension = getMaxWindowPixelDimension();
    const requiredSize = {width: maxWindowDimension, devicePixelRatio: (maxWindowDimension <= 1550 ? 1.0 : maxWindowDimension <= 2325 ? 1.5 : 2)};
    const file = this.getHomeHeaderPicUrl(requiredSize);
    const backgroundImage = `url(${file})`;

    return (
      <div
        style={{
          position: 'relative',
          height: height,
          backgroundSize: 'cover',
          backgroundImage
        }} name="HomeBanner">
        <div style={styles.companyDetails}>
          <span style={styles.companyName}>{window.gs.companyName}</span>
          <span style={styles.companyTagLine}>{window.gs.companyTagLine}</span>
        </div>
      </div>
    );
  }

  getHomeHeaderPicUrl(sizeFilter): string {
    var maxFitFound = null;
    var ceilingSizeFound = null;
    if (window.homeHeaderSrcSetSizes) {
      window.homeHeaderSrcSetSizes.forEach((s) => {
        const num = Number.parseFloat(s.size);
        if (Number.isNaN(num)) {
          return;
        }
        if (s.size.endsWith('x')) {
          if (num >= sizeFilter.devicePixelRatio) {
            if (maxFitFound === null || (num < ceilingSizeFound && maxFitFound.size.endsWith('x'))) {
              maxFitFound = s;
              ceilingSizeFound = num;
            }
          }
          return;
        } else {
          if (num >= sizeFilter.width) {
            if (maxFitFound === null || num < ceilingSizeFound || maxFitFound.size.endsWith('x')) {
              maxFitFound = s;
              ceilingSizeFound = num;
            }
          }
          return;
        }
      });
    }
    if (maxFitFound !== null) {
      return System.isDesktop() ? maxFitFound.path : ThumbnailUtil.getHomeHeaderPicUrl(maxFitFound.size);
    } else if (window.homeHeaderExists) {
      return System.isDesktop() ? window.homeHeaderExists : ThumbnailUtil.getHomeHeaderPicUrl();
    } else {
      const installedSizes = [1550, 2325, 3100];
      ceilingSizeFound = installedSizes.find((s) => sizeFilter.width < s);
      if (!ceilingSizeFound)
        ceilingSizeFound = installedSizes[installedSizes.length - 1];
      return 'images/home_header_' + ceilingSizeFound + 'w.jpg';
    }
  }
}

const styles = {
  companyDetails: {
    color: '#B5B5B5',
    position: 'absolute',
    bottom: '20px',
    textAlign: 'center',
    width: '100%'
  },
  companyName: {
    display: 'block',
    marginBottom: '11px',
    height: '29px',
    color: '#FFFFFF',
    fontSize: '24px',
    fontWeight: '600',
    lineHeight: '29px',
    textAlign: 'center',
    textShadow: '2px 2px #333'
  },
  companyTagLine: {
    height: '19px',
    color: '#B5B5B5',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '19px',
    textAlign: 'center',
    textShadow: '-1px 1px #333'
  }
};
